<av-card class="fx-column fx-flex-1">
  <av-card-body
    size="sm"
    type="container"
    class="fx-flex-1 fx-column fx-align-stretch"
    #bodyRef
  >
    @for (m of messages | orderBy : 'timestamp'; track m) {
    <app-conversation-item [message]="m"></app-conversation-item>
    }
  </av-card-body>
  <av-card-footer>
    <app-conversation-input></app-conversation-input>
  </av-card-footer>
</av-card>
